import { Text, Icon, Flex, VStack, Box, Badge } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { TapeBuilderUI } from '@finley-technologies/tape-builder';

import { RenderNodeProps, useNodeColors } from './RenderNodeProps';
import { FiCheckCircle } from 'react-icons/fi';

export const getBadges = (nodeType: TapeBuilderUI.TapeBuilderNodeType) => {
  const uiNode = TapeBuilderUI.getUINodeByType(nodeType);
  let colorScheme: string = 'white';
  finleyAssert(!uiNode.isOperation, 'Operation nodes do not have badges');
  if (uiNode.isFinal) {
    colorScheme = 'green';
  } else if (uiNode.isRaw) {
    colorScheme = 'blue';
  } else {
    colorScheme = 'yellow';
  }
  return (
    <Text fontSize="md" fontWeight="light">
      {uiNode.badgeTexts.map((badgeText) => (
        <Badge key={badgeText} variant="outline" colorScheme={colorScheme}>
          {badgeText}
        </Badge>
      ))}
    </Text>
  );
};

export const TapeNode = ({
  nodeText,
  nodeType,
  selected = false,
  hasInputs = false,
  draggable = false,
  children,
}: RenderNodeProps) => {
  const playIconSize = '80px'; // Increased size for play icon
  const {
    bgColor,
    textColor,
    borderColor,
    selectedBorderColor,
    iconColor,
    unSelectedBorderSize,
    selectedBorderSize,
  } = useNodeColors();

  return (
    <Box
      bg={bgColor}
      color={textColor}
      draggable={draggable}
      onDragStart={(event) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        // eslint-disable-next-line no-param-reassign
        event.dataTransfer.effectAllowed = 'move';
      }}
      borderRadius={10}
      border={
        selected
          ? `solid ${selectedBorderSize}`
          : `solid ${unSelectedBorderSize}`
      }
      borderColor={selected ? selectedBorderColor : borderColor}
      padding="10px"
    >
      <Flex alignItems="center">
        {hasInputs && (
          <Icon as={FiCheckCircle} color={iconColor} boxSize={playIconSize} />
        )}
        <VStack>
          <Text maxWidth="180px" noOfLines={1} wordBreak="break-all">
            {nodeText}
          </Text>

          {getBadges(nodeType)}
          {children}
        </VStack>
      </Flex>
    </Box>
  );
};
